"use strict";
/**
 * @file Created on 02.06.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NotificationDocConverter_1 = require("../NotificationDocConverter");
/**
 * @author Tomas Leity
 */


var NChangedWinDateConverter =
/*#__PURE__*/
function (_NotificationDocConve) {
  _inherits(NChangedWinDateConverter, _NotificationDocConve);

  function NChangedWinDateConverter() {
    _classCallCheck(this, NChangedWinDateConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(NChangedWinDateConverter).apply(this, arguments));
  }

  return NChangedWinDateConverter;
}(NotificationDocConverter_1.NotificationDocConverter);

exports.NChangedWinDateConverter = NChangedWinDateConverter;